var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.textMode && _vm.welcome_msg_status)?[_c('Welcome',{attrs:{"path":_vm.path}})]:[_c('Queue',{attrs:{"nums":_vm.data,"call_type":_vm.active}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }